import API from '@aws-amplify/api';
import Constant from '@/common/constant/Constant';
import { checkViewTicketPermission} from '@/graphql/queries';
export const anonymousAccessShareLinkTicket = async (APIClient,ticketId,affiliationProject,affiliationOrganizationDomain) => {
    let checkPermissionResult = await API.graphql({
        query: checkViewTicketPermission,
        variables: {
            params: {
                userId: 'anonymous',
                ticketId: ticketId,
                affiliationOrganizationDomain: affiliationOrganizationDomain,
                affiliationProject: affiliationProject
            }
        },
        authMode: Constant.AUTH_MODE_API_KEY,
    });
    return checkPermissionResult.data.checkViewTicketPermission
}

export const userAccessShareLinkTicket = async (
    userId,
    ticketId,
    projectInuseId,
    affiliationOrganizationDomain,
    affiliationProject,
    chatPostId,
    openFromNotify = false
) => {
    let checkPermissionResult = await API.graphql({
        query: checkViewTicketPermission,
        variables: {
            params: {
                userId: userId,
                ticketId: ticketId,
                chatPostId,
                projectInuseId: projectInuseId,
                corporationInuseId: null,
                affiliationOrganizationDomain: affiliationOrganizationDomain,
                affiliationProject: affiliationProject,
                openFromNotify
            }
        }
    });
    return checkPermissionResult.data.checkViewTicketPermission
}